require('./bootstrap');

require('alpinejs');
require('owl.carousel');

window.toastr = require('toastr');
window.datetimepicker = require('jquery-datetimepicker');

// Custom JS

$(document).ready(function () {


    var current_fs, next_fs, previous_fs; //fieldsets
    var opacity;
    var current = 1;
    let count = 1;
    var steps = $("fieldset").length;
    var cause;

    setProgressBar(current);

    const vowels = ['A', 'E', 'I', 'O', 'U']


    const content = $('fieldset#fs .form-group');
    const animalsArray = [];


    function hideShowAnimals () {
        animalsArray.forEach(animal => {
            $(`input[value="${animal}"]`).parent().parent('.col-sm-3').hide();
        })
    }


    $('#submit').on('click', function() {
        let hasError = false;
        $('.error').remove()

        let name = $('#first_name').val()

        if (name.trim() === '') {
            hasError = true;
            $(this).before('<span class="error">Please enter your name</span>')
        }
        if (name && name.trim().length < 2) {
            hasError = true;
            $(this).before('<span class="error">Name should be more than 2 characters</span>')
        }

        if(hasError){
            return false;
        }
        return true;

    })

    $(".next").on("click", function () {

        let hasError = false;
        $('.error').remove()

        if($(this).hasClass('text')){
            let name = $(this).siblings('.form-card').find('input[type="text"]').val();
            try {
                if (name == '' || name == undefined) {
                    hasError = true;
                    if($(this).hasClass('romance')){
                        $(this).before('<span class="error">Please enter the name of the person you are giving this to.</span>')
                    } else if($(this).hasClass('appreciation')) {
                        $(this).before('<span class="error">Please enter a name.</span>')
                    } else if($(this).hasClass('diversity')) {
                        $(this).before('<span class="error">Please enter text.</span>')
                    } else {
                        $(this).before('<span class="error">Please Fill In Your Name.</span>')
                    }
                }
                if (name && name.trim().length < 2) {
                    hasError = true;
                    $(this).before('<span class="error">Name should be more than 2 characters.</span>')
                }
            } catch (error) {
                console.log(error);
            }
        }
        if($(this).hasClass('radio')){
            if($(this).hasClass('animalAction')){
                let animal = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[name="selectAnimal"]:checked').val();
                let action = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[name="selectAction"]:checked').val();

                if (animal === undefined || action === undefined) {
                    hasError = true;
                    $(this).before('<span class="error">Please select options before pressing Next.</span>')
                }
            }
            else{
                let radioValues = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="radio"]:checked').val()
                try {
                    if (radioValues === undefined) {
                        hasError = true;
                        $(this).before('<span class="error">Please select one of the items before pressing Next.</span>')
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
        if($(this).hasClass('checkbox')){
            if($(this).hasClass('bestAnimals') && !hasError){
                let answer = ['Buffalo', 'Bumblebee', 'Centipede', 'Coyote', 'Crocodile', 'Elephant', 'Flamingo', 'Tall Giraffe', 'Iguana', 'Kangaroo', 'Ladybug', 'Pelican', 'Polar bear', 'Porcupine', 'Sea lion', 'Striped Tiger']
                let res = 0;
                let option = [];
    
                var cboxes = document.getElementsByName('bestAnimals[]');
                var len = cboxes.length;
    
                for (var i=0; i<len; i++) {
                    if(cboxes[i].checked){
                        option.push(cboxes[i].value);
                    }
                }
    
                if(option.length == 0){
                    hasError = true;
                    $(this).before(`<span class="error">Whoops!! Please select animals.</span>`)
                }
                else{

                    let numberToCheck = parseInt($(this).attr('data-total'))
                    checkboxLength = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="checkbox"]:checked').length;
                    if (checkboxLength !== numberToCheck) {
                        hasError = true;
                        $(this).before(`<span class="error">Please select ${numberToCheck} options.</span>`)
                    }
                    else{
                        $.each(option, (index, element) => {
                            if(answer.includes(element)){
                                if(res != 2){
                                    res = 1;
                                }
                            }
                            else{
                                res = 2;
                            }
                        });
            
                        if(res == 2){
                            hasError = true;
                            $(this).before(`<span class="error">Whoops!! That is the wrong answer. Try again.</span>`)
                            let audioElement = new Audio(app_url + '/images/media/uh-oh.wav');
                            audioElement.play();
        
                            $.each($('.bestAnimalsArray input[type=checkbox]'), function(){
                                $(this).prop('checked', false)
                                $(this).parent().removeClass('active');
                                $(this).parent().removeClass('active-wrong');
                                $(this).parent().removeClass('active-correct');
                            });
                        }
                        else{
                            $('#numberOfAnimals').modal();
                            let audioElement = new Audio(app_url + '/images/media/success-notification.wav');
                            audioElement.play();
                        }
                    }
                    
                }
            }
            else {
                let numberToCheck = parseInt($(this).attr('data-total'))
                checkboxLength = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="checkbox"]:checked').length;
                try {
                    if (checkboxLength !== numberToCheck) {
                        hasError = true;
                        $(this).before(`<span class="error">Please select ${numberToCheck} options.</span>`)
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
        if($(this).hasClass('checkbox-upto')){
            checkboxLength = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="checkbox"]:checked').length;
            try {
                if (checkboxLength < 1) {
                    hasError = true;
                    $(this).before(`<span class="error">Please select atleast one option.</span>`)
                }
            } catch (error) {
                console.log(error);
            }
        }
        if($(this).hasClass('checkbox-nullable')){
            let numberToCheck = parseInt($(this).attr('data-total'))
            let no_travel = $('input[name=no_travel]:checked').val()
            if(!no_travel){
                checkboxLength = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="checkbox"]:checked').length;
                try {
                    if (checkboxLength !== numberToCheck) {
                        hasError = true;
                        $(this).before(`<span class="error">Please select ${numberToCheck} options.</span>`)
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
        if($(this).hasClass('numberOfAnimals') && !hasError){
            let answer = 17
            let option = $('input[name=numberOfAnimals]:checked').val()
            if(answer == option){
                $('#numberOfAnimals').modal();
                let audioElement = new Audio(app_url + '/images/media/success-notification.wav');
                audioElement.play();
            }
            else{
                hasError = true;
                if(answer > option){
                    $(this).before(`<span class="error">Whoops!! There are more animals than that. Try again.</span>`)
                }
                else{
                    $(this).before(`<span class="error">Whoops!! There are fewer animals than that. Try again.</span>`)
                }
                let audioElement = new Audio(app_url + '/images/media/uh-oh.wav');
                audioElement.play();
            }
        }
        if($(this).hasClass('animalsSameAsHumans') && !hasError){
            let answer = 17
            let option = '';

            var cboxes = document.getElementsByName('animalsSameAsHumans[]');
            var len = cboxes.length;
            for (var i=0; i<len; i++) {
                if(cboxes[i].checked){
                    option += cboxes[i].value + ',';
                }
            }

            if(option == 'They talk about what happens in the news,They all have something to say,' || option == 'They all have something to say,They talk about what happens in the news,' || option ==  'They all have something to say,' || option == 'They talk about what happens in the news,'){
                $('#numberOfAnimals').modal();
                let audioElement = new Audio(app_url + '/images/media/success-notification.wav');
                audioElement.play();
            }
            else{
                hasError = true;
                $(this).before(`<span class="error">Whoops!! You choose the wrong answer. Try again.</span>`)
                
                let audioElement = new Audio(app_url + '/images/media/uh-oh.wav');
                audioElement.play();

                $.each($('.animalsSameAsHumansArray input[type=checkbox]'), function(){
                    $(this).prop('checked', false)
                    $(this).parent().removeClass('active');
                });

            }
        }
        if($(this).hasClass('verseDifference') && !hasError){
            let answer = 'Something that looked unusual was all right in the end'
            let option = $('input[name=verseDifference]:checked').val()
            if(answer == option){
                $('#numberOfAnimals').modal();
                let audioElement = new Audio(app_url + '/images/media/success-notification.wav');
                audioElement.play();
            }
            else{
                hasError = true;
                $(this).before(`<span class="error">Whoops!! That is the wrong answer. Try again.</span>`)
                let audioElement = new Audio(app_url + '/images/media/uh-oh.wav');
                audioElement.play();
            }
        }
        if($(this).hasClass('bestAnimals') && !hasError){
            let answer = ['Buffalo', 'Bumblebee', 'Centipede', 'Coyote', 'Crocodile', 'Elephant', 'Flamingo', 'Tall Giraffe', 'Iguana', 'Kangaroo', 'Ladybug', 'Pelican', 'Polar bear', 'Porcupine', 'Sea lion', 'Striped Tiger']
            let res = 0;
            let option = [];

            var cboxes = document.getElementsByName('bestAnimals[]');
            var len = cboxes.length;

            for (var i=0; i<len; i++) {
                if(cboxes[i].checked){
                    option.push(cboxes[i].value);
                }
            }

            if(option == undefined){
                hasError = true;
                $(this).before(`<span class="error">Whoops!! Please select animals.</span>`)
            }
            else{
                $.each(option, (index, element) => {
                    if(answer.includes(element)){
                        if(res != 2){
                            res = 1;
                        }
                    }
                    else{
                        res = 2;
                    }
                });
    
                if(res == 2){
                    hasError = true;
                    $(this).before(`<span class="error">Whoops!! That is the wrong answer. Try again.</span>`)
                    let audioElement = new Audio(app_url + '/images/media/uh-oh.wav');
                    audioElement.play();

                    $.each($('.bestAnimalsArray input[type=checkbox]'), function(){
                        $(this).prop('checked', false)
                        $(this).parent().removeClass('active');
                    });
                }
                else{
                    $('#numberOfAnimals').modal();
                    let audioElement = new Audio(app_url + '/images/media/success-notification.wav');
                    audioElement.play();
                }
            }
        }
        


        if(hasError){
            return false;
        }
        else {

            if($(this).hasClass('animals-ding')){
                let audioElement = new Audio(app_url + '/images/media/jungle-complete-ding.mp3');
                audioElement.play();
            }
            else{
                let audioElement = new Audio(app_url + '/images/media/correct-answer.mp3');
                audioElement.play();
            }

            current_fs = $(this).parent();
            next_fs = $(this).parent().next();

            if($(this).hasClass('cause')){
                cause = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="radio"]:checked').val();
                if(cause !== 'broke'){
                    console.log('next next');
                    next_fs = $(this).parent().next().next();
                } else {
                    console.log('next');
                    next_fs = $(this).parent().next();
                }
            }


            if(current_fs.hasClass('poem_fs')){
                $('.wrapper').css('height', '100%')
            }
            
            if($(this).hasClass('animals')){
                let animal = $(this).siblings('.form-card').children('.form-group').children('.row').find('input[type="checkbox"]:checked');
                animalsArray.push(animal[0].value);
                animalsArray.push(animal[1].value);
                $(`input[type="checkbox"]`).parent().parent('.col-3').show();
                hideShowAnimals();

                if((next_fs).hasClass('poem_fs')){
                    // $('.wrapper').css('height', '100vh')
                    document.getElementById('poem').scrollIntoView({
                        behavior: 'smooth'
                      });
                      
                    let poem;
                    switch (count) {
                        case 1:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} wearing pajamas <br />
                            Is quite an unusual sight <br />
                            ${vowels.includes(animal[1].value[0]) ? 'An' : 'A'} ${animal[1].value.toLowerCase()} peeling bananas <br />
                            It appears that something's not right`;
                            break;
                        case 2:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} knitting a sweater <br />
                            Is not what you normally see <br />
                            ${vowels.includes(animal[1].value[0]) ? 'An' : 'A'} ${animal[1].value.toLowerCase()} writing a letter <br />
                            Would be an exception to me
                            `;
                            break;
                        case 3:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} plays on the fiddle <br />
                            You hear and are taken aback <br />
                            Did ${vowels.includes(animal[1].value[0]) ? 'an' : 'a'} ${animal[1].value.toLowerCase()} try out a riddle? <br />
                            A duck answers quick with a quack
                            `;
                            break;
                        case 4:
                            poem = `The ${animal[0].value.toLowerCase()}s often go hopping <br />
                            While visiting friends in the town <br />
                            Join ${vowels.includes(animal[1].value[0]) ? 'an' : 'a'} ${animal[1].value.toLowerCase()} downtown shopping <br />
                            For a necklace, or even a gown
                            `;
                            break;
                        case 5:
                            poem = `The ${animal[0].value.toLowerCase()}s are practicing yoga <br />
                            They stretch out their bodies so tall <br />
                            ${vowels.includes(animal[1].value[0]) ? 'An' : 'A'} ${animal[1].value.toLowerCase()}'s wearing a toga <br />
                            It might be too big or too small
                            `;
                            break;
                        case 6:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} planting a flower <br />
                            Is thinking of taking a stroll <br />
                            With ${vowels.includes(animal[1].value[0]) ? 'an' : 'a'} ${animal[1].value.toLowerCase()} just for an hour <br />
                            To exercise more is her goal  
                            `;
                            break;
                        case 7:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} taking some classes <br />
                            ${animal[1].value}s who are learning to talk <br />
                            They're often found wearing their glasses <br />
                            While reading their books on the dock
                            `;
                            break;
                        case 8:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} washing the dishes <br />
                            Can't happen too often you say <br />
                            ${vowels.includes(animal[1].value[0]) ? 'An' : 'A'} ${animal[1].value.toLowerCase()} giving three wishes <br />
                            Is not what you see every day
                            `;
                            break;                
                        default:
                            poem = `${vowels.includes(animal[0].value[0]) ? 'An' : 'A'} ${animal[0].value.toLowerCase()} wearing pajamas <br />
                            is quite an unusual sight <br />
                            ${vowels.includes(animal[1].value[0]) ? 'An' : 'A'} ${animal[1].value.toLowerCase()} peeling bananas <br />
                            it appears that something's not right`;
                            break;
                    }
                    // console.log(current);
                    next_fs.find('img.image1').attr('src', app_url + '/images/animals/' + animalsArray[animalsArray.length-2].split(' ').join('-') + '.jpg')
                    next_fs.find('img.image2').attr('src', app_url + '/images/animals/' + animalsArray[animalsArray.length-1].split(' ').join('-') + '.jpg')
                    next_fs.find('p').html(poem)
                }
            }


            //Add Class Active
            $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
    
            //show the next fieldset
            next_fs.show();
            //hide the current fieldset with style
            current_fs.animate({
                opacity: 0
            }, {
                step: function (now) {
                    // for making fielset appear animation
                    opacity = 1 - now;
    
                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    next_fs.css({
                        'opacity': opacity
                    });
                },
                duration: 500
            });
            setProgressBar(++current);
            if(!next_fs.hasClass('poem_fs')){
                ++count;
            }
        }
    });

    $(".previous").click(function () {

        let audioElement = new Audio(app_url + '/images/media/correct-answer.mp3');
        audioElement.play();

        current_fs = $(this).parent();
        previous_fs = $(this).parent().prev();


        if($(this).hasClass('cause')){
            console.log(cause);
            if(cause !== 'broke'){
                previous_fs = $(this).parent().prev().prev();
            } else {
                previous_fs = $(this).parent().prev();
            }
        }


        //Remove class active
        $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

        //show the previous fieldset
        previous_fs.show();

        //hide the current fieldset with style
        current_fs.animate({
            opacity: 0
        }, {
            step: function (now) {
                // for making fielset appear animation
                opacity = 1 - now;

                current_fs.css({
                    'display': 'none',
                    'position': 'relative'
                });
                previous_fs.css({
                    'opacity': opacity
                });
            },
            duration: 500
        });
        setProgressBar(--current);

        if($(this).hasClass('animals') && current_fs.hasClass('poem_fs')){
            // console.log(animalsArray);
            $(`input[value="${animalsArray[animalsArray.length-2]}"]`).parent().parent('.col-3').show();
            $(`input[value="${animalsArray[animalsArray.length-1]}"]`).parent().parent('.col-3').show();
            animalsArray.pop();
            animalsArray.pop();
            // console.log(animalsArray);
            // $(`input[type="checkbox"]`).parent().parent('.col-3').show();
        }

    });

    function setProgressBar(curStep) {
        var percent = parseFloat(100 / steps) * curStep;
        percent = percent.toFixed();
        $(".progress-bar")
            .css("width", percent + "%")
    }

    $(".submit").click(function () {
        return false;
    });

    $('input[type=checkbox]').on('click', function() {
        let total = $(this).parent().parent().parent().parent('.form-group').parent('.form-card').siblings('.next.checkbox').attr('data-total')
        total = parseInt(total);
        let checkboxLength = $(this).parent().parent().parent().find('input[type=checkbox]:checked').length;
        if(checkboxLength > total){
            $(this).prop('checked', false);
            return false;
        } else {
            if($(this).hasClass('best-animal')) {
                let answer = ['Buffalo', 'Bumblebee', 'Centipede', 'Coyote', 'Crocodile', 'Elephant', 'Flamingo', 'Tall Giraffe', 'Iguana', 'Kangaroo', 'Ladybug', 'Pelican', 'Polar bear', 'Porcupine', 'Sea lion', 'Striped Tiger']
                if(answer.includes($(this).val())) {
                    if($(this).is(':checked')){
                        $(this).parent('label').addClass('active-correct')
                    } else {
                        $(this).parent('label').removeClass('active-correct')
                    }
                } else {
                    if($(this).is(':checked')){
                        $(this).parent('label').addClass('active-wrong')
                    } else {
                        $(this).parent('label').removeClass('active-wrong')
                    }
                }
            } else {
                if($(this).is(':checked')){
                    $(this).parent('label').addClass('active')
                } else {
                    $(this).parent('label').removeClass('active')
                }
            }
        }
    });


    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }


      function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      $('.animalsForm').on('submit', function(e) {
          setCookie('animals', animalsArray.toString(), 1)
          debugger
      });

});

// ravikiran js start 
$(".register-button").click(function () {
    $("#profile").removeClass("active");
    $(".front-modal").addClass("hide");
    $("#home").addClass("active");
});
$(".register-tag").click(function () {
    $("#profile").removeClass("active");
    $(".front-modal").addClass("hide");
    $("#home").addClass("active");
});
$(".login-button").click(function () {
     $("#profile").addClass("active");
     $(".front-modal").addClass("hide");
     $("#home").removeClass("active");
    
});
$(".login-tag").click(function () {
    $("#profile").addClass("active");
    $(".front-modal").addClass("hide");
    $("#home").removeClass("active");

});
$(".back-option").click(function () {
    $("#profile").removeClass("active");
    $("#home").removeClass("active");
    $(".front-modal").removeClass("hide");
});


// Jay Auth

$("#popup-login").on("click", function(){
    let email = $("#popup-login-form input[name=email]").val();
    let password = $("#popup-login-form input[name=password]").val();
    let remember = $("#popup-login-form input[name=remember]").is(':checked');

    $(this).attr('disable', true);
    $(this).html(`<div class="spinner-border spinner-border-sm text-light mb-1" role="status">
        <span class="sr-only">Loading...</span>
    </div><span class='my-auto'> Log in</span>`);
    
    $.ajax({
        url: app_url + '/login',
        type: 'POST',
        data: {
            _token: csrf,
            email: email,
            password: password,
            remember: remember
        },
        success: function(response){
            window.location.reload();
        },
        error: function(error){
            $('#login-error').removeClass('d-none');
            $('#login-error').html("Invalid Email / Password");
            setTimeout(() => {
                $('#login-error').addClass('d-none');
                $('#login-error').trigger('')
            }, 3000);
            $("#popup-login").attr('disable', false);
            $("#popup-login").html('Log in');
        }
    });

});

$("#popup-signup").on("click", function(){
    let name = $("#popup-signup-form input[name=name]").val();
    let email = $("#popup-signup-form input[name=email]").val();
    let password = $("#popup-signup-form input[name=password]").val();
    let password_confirmation = $("#popup-signup-form input[name=password_confirmation]").val();
    let terms = $("#popup-signup-form input[name=terms]").is(':checked');

    $(this).attr('disable', true);
    $(this).html(`<div class="spinner-border spinner-border-sm text-light mb-1" role="status">
        <span class="sr-only">Loading...</span>
    </div><span class='my-auto'> Sign Up</span>`);

    
    $.ajax({
        url: app_url + '/register',
        type: 'POST',
        data: {
            _token: csrf,
            name: name,
            email: email,
            password: password,
            password_confirmation: password_confirmation,
            terms: terms
        },
        success: function(response){
            window.location.reload();
        },
        error: function(error){
            if(error.status == '403'){
                window.location.href = app_url + "/dashboard";
            }
            else{
                $('#signup-error').removeClass('d-none');
                setTimeout(() => {
                    $('#signup-error').addClass('d-none');
                }, 3000);    

                $("#popup-signup").attr('disable', false);
                $("#popup-signup").html('Sign Up');    
            }
        }
    }).fail(function( data ) {
        let response = JSON.parse(data.responseText);
        let errorString = '<ul>';
        $.each( response.errors, function( key, value) {
            errorString += '<li>' + value + '</li>';
        });
        errorString += '</ul>';
        $('#signup-error').html(errorString);

        $("#popup-signup").attr('disable', false);
        $("#popup-signup").html('Sign Up');

    });
});


$('#submitComment').on('submit', function(e){
    e.preventDefault();
    $.ajax({
        url: app_url + '/bravo-board',
        type: 'POST',
        data: $('#submitComment').serialize(),
        success: function(response){
            $('#submitComment textarea').val('');
            $('#submitComment textarea').after('<p class="text-success">Your comment has been submitted!</p>');

            let username = '';
            if(response.user != '' && response.user != null && response.user != undefined){
                username = response.user.name;
            }
            else{
                username = 'John Doe';
            }

            $('.bravo-comment-list ul').prepend(`
            <li class='bravo-comment-card glow'>
                <div class='row'>
                    <div class='col-lg-9'>
                        <div class='bravo-comment-text'>
                            <p>
                                ${ response.comment }
                            </p>
                        </div>
                    </div>
                    <div class='col-lg-3 px-lg-0 mt-4 mt-lg-0'>
                        <div class='bravo-comment-profile-wrap'>
                            <div class='text-lg-left'>
                                <div class='bravo-comment-profile d-inline-flex align-items-center'>
                                    <div class='bravo-profile-name'>
                                        <p class='mb-0'>${ username }</p>
                                    </div>
                                </div>
                            </div>
                            <div class='bravo-comment-action-wrap d-flex align-items-center justify-content-lg-between'>
                                <div class='bravo-comment-action d-inline-flex align-items-center'>
                                    <button class='btn btn-link pl-0 bravo-emoji text-decoration-none d-flex align-items-center bravoComment' data-bravo-board=${ response.id }><img src='/images/bravo-board/bravo-clap.png' alt='bravo'> <span> Bravo </span></button> 
                                    <span class='bravo-comments-count'>0</span>
                                </div>
                            </div>
                            <div class='bravo-comment-date'>
                            </div>
                        </div>
                    </div>
                </div>
            </li>`);

            let audioElement = new Audio(app_url + '/images/media/mixkit-correct-answer-tone-2870.wav');
            audioElement.play();

            // setTimeout(() => {
            //     window.location.reload();
            // }, 3000);
        },
        error: function(error){
            toastr.error('Unable to submit your comment.');
        }
    });
});